<div class="map" [ngStyle]="{ width: containerWidth }">
    @if(showSearchTextbox) {
    <div class="place-box" [ngStyle]="{ width: containerWidth }">
        <input type="text" class="search-box" placeholder="Search Location" type="text" #search />
        <button class="btn-location" (click)="getCurrentLocation()">
            <i class="fas fa-lg fa-crosshairs" aria-hidden="true"></i>
        </button>
    </div>
    }
    <div class="mapcontainer">
        <google-map #map="googleMap" [options]="options" [zoom]="zoom" [width]="mapWidth" [center]="mapCenter"
            (mapClick)="mapClicked($event)">
            @for (location of markerList; track location; let index = $index) {
            <map-advanced-marker #markerElem="mapAdvancedMarker" [position]="{ lat: location.lat, lng: location.lng }"
                [title]="location.title" (mapClick)="onMapMarkerClicked(location)" />
            }
            @if(locationPosition) {
            <map-advanced-marker [position]="locationPosition"></map-advanced-marker>
            }
        </google-map>
    </div>
</div>